import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {AttachmentBaseContainer} from '../../../../../../../../src/components/inboxes/viewer/activity/attachments/attachmentBaseContainer';
import {Trans} from '../../../../../../../shared/helpers/src/internationalization/react';

/*
 * Style.
 */

interface AttachmentStyleProps {
  $hasError: boolean;
}
const StyledAttachmentDiv = styled.div<AttachmentStyleProps>`
  flex: 1;
  display: inline-flex;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${(p) => p.theme.alphas.black40};
  ${(p) => addBackgroundStyle(p.$hasError)};
`;

function addBackgroundStyle(hasError: boolean) {
  if (hasError) {
    return css`
      background-color: ${(p) => p.theme.palette.red.shade10};
      &:hover {
        background-color: ${(p) => p.theme.palette.red.shade20};
      }
    `;
  }

  return css`
    background-color: ${(p) => p.theme.foreground};
    &:hover {
      background-color: ${(p) => p.theme.greys.shade20};
    }
  `;
}

/*
 * Component.
 */

export const DragAndDropAttachment: FC<React.ComponentProps<typeof AttachmentBaseContainer>> = (props) => {
  const {hasError} = props;

  return (
    <StyledAttachmentDiv $hasError={Boolean(hasError)}>
      <AttachmentBaseContainer
        {...props}
        hasError={hasError}
        shouldDisablePreview
        customErrorMessage={<Trans id="drag-and-drop-failed-custom-error">Failed to import</Trans>}
      />
    </StyledAttachmentDiv>
  );
};
